module.exports = __webpack_public_path__ + "img/TechTower4_ua.591a905f.webp";